  document.addEventListener("DOMContentLoaded", function () {
    const popup = document.getElementById("welcome-popup");
    const closeButton = document.getElementById("popup-close");
     const inneriframe = document.querySelector(".ctm_popup__bottom iframe");
    const popupBody = document.body;
    const ckpopupopen = document.getElementById("ck_popup_open");
    
    // Function to set a cookie
    // function setCookie(name, value, days) {
    //   const date = new Date();
    //   date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    //   document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
    // }

    // Function to get a cookie value
    // function getCookie(name) {
    //   const cookies = document.cookie.split("; ");
    //   for (let i = 0; i < cookies.length; i++) {
    //     const [key, value] = cookies[i].split("=");
    //     if (key === name) {
    //       return value;
    //     }
    //   }
    //   return null;
    // }

    // Check if the popup should be displayed
    // if (!getCookie("popupClosed")) {
    //    setTimeout(() => {
    //   popup.classList.remove("hidden");
    //   popupBody.classList.add("popup_opened");
    //      }, 3000);
    // }

    if (ckpopupopen){
      ckpopupopen.addEventListener("click", function (e) {
        e.preventDefault();
          popup.classList.remove("hidden");
          popupBody.classList.add("popup_opened")
        });
      }
    

    // Close the popup and set a cookie
    closeButton.addEventListener("click", function () {
      popup.classList.add("hidden");
      popupBody.classList.remove("popup_opened");
      // setCookie("popupClosed", "true", 30);
      if (inneriframe) {
            let src = inneriframe.src;
            inneriframe.src = ""; // Clear the src to stop the video
            setTimeout(() => {
                inneriframe.src = src; // Restore the src when needed
            }, 300);
        }
    });


    // Select all the .cart-item parent elements
  const cartItems = document.querySelectorAll('.cart-item');

  cartItems.forEach((cartItem, index) => {
    // Find the source <a> and target <img> elements inside each .cart-item
    const sourceElement = cartItem.querySelector('.get__img__links');
    const targetImage = cartItem.querySelector('.add_img__links');

    if (sourceElement && targetImage) {
      const newSrc = sourceElement.getAttribute('href'); // Get href from the <a> tag
      console.log(`Cart Item ${index + 1} - Source URL:`, newSrc);

      // Update the image src attribute
      targetImage.setAttribute('src', newSrc);
      console.log(`Cart Item ${index + 1} - Updated Image Src:`, targetImage.getAttribute('src'));
    } else {
      console.log(`Cart Item ${index + 1} - Source or Target Image Not Found`);
    }
  });
  });


 document.addEventListener("DOMContentLoaded", function () {
  const countrySelect = document.querySelector('select#AddressCountryNew');
  if (countrySelect) {
    const firstOption = countrySelect.querySelector('option[data-provinces="[]"]');
    if (firstOption) {
      firstOption.textContent = "Select a country*";
    }
  }
});